import AnnouncementsPageContent from '@/components/pages/announcements-page';

export default function AnnouncementsPage() {
  return <AnnouncementsPageContent />;
}
